import { FraudStatementSearchRequestQuery } from '@lio/api-types';

export const getFraudStatementQuery = (params: FraudStatementSearchRequestQuery) => {
  const { sort, includeHistorical, jurisdictionId, pageLimit, pageOffset } = params;
  const query = new URLSearchParams();

  if (sort) {
    query.append('sort', sort);
  }

  if (typeof includeHistorical === 'boolean') {
    query.append('includeHistorical', includeHistorical.toString());
  }
  if (jurisdictionId) {
    query.append('jurisdictionId', jurisdictionId);
  }

  query.append('pageLimit', pageLimit?.toString() ?? '50');

  if (pageOffset) {
    query.append('pageOffset', pageOffset.toString());
  }

  return query.toString();
};
